import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TourismMapRequest } from './tourism-map.model';

@Injectable({
  providedIn: 'root'
})
export class TourismMapService {
  private apiUrl = environment.apiBaseUrl + '/api/tourism-map';

  constructor(private http: HttpClient) { }

  getAll(langCode = ''): Observable<any> {
    return langCode
      ? this.http.get(`${this.apiUrl}?lang=${langCode}`)
      : this.http.get(this.apiUrl);
  }

  getById(id: number, langCode = ''): Observable<any> {
    return langCode
      ? this.http.get(`${this.apiUrl}/${id}?lang=${langCode}`)
      : this.http.get(`${this.apiUrl}/${id}`);
  }

  create(request: TourismMapRequest): Observable<any> {
    const formData = this.toFormData(request);

    return this.http.post(this.apiUrl, formData);
  }

  update(id: number, request: TourismMapRequest): Observable<any> {
    const formData = this.toFormData(request);

    return this.http.put(`${this.apiUrl}/${id}`, formData);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  private toFormData(request: TourismMapRequest): FormData {
    const formData = new FormData();

    if (request.image) {
      formData.append('Image', request.image);
    }

    formData.append('Data', JSON.stringify(request.data));

    return formData;
  }
}
